module.exports = __webpack_public_path__ + "media/images/shared/icon_select_arrow-108618a041e669128196df5be71f5de9.png";